import {gql} from "@apollo/client";

export const GET_CONDITIONS = gql`
  query GetConditions {
    conditions(orderBy: {field: asc}) {
      id
      field
      isDeleted
      fieldType
      listOptions {
        id
        name
        description
      }
      inUseBy {
        model
        count
      }
    }
  }
`;
export const CREATE_CONDITION = gql`
  mutation CreateCondition(
    $field: String!
    $fieldType: ConditionType!
    $listOptions: [ListOptionCreateManyConditionInput!]!
  ) {
    createOneCondition(
      data: {
        field: $field
        fieldType: $fieldType
        listOptions: {createMany: {data: $listOptions}}
      }
    ) {
      id
      field
      isDeleted
      fieldType
      listOptions {
        id
        name
        description
      }
    }
  }
`;
export const UPDATE_CONDITION = gql`
  mutation UpdateCondition(
    $conditionId: Int!
    $field: String!
    $fieldType: ConditionType!
    $optionsToDelete: [Int!]
    $optionsToCreate: [ListOptionCreateManyConditionInput!]!
    $optionsToUpdate: [ListOptionUpdateWithWhereUniqueWithoutConditionInput!]
  ) {
    updateOneCondition(
      where: {id: $conditionId}
      data: {
        field: {set: $field}
        fieldType: {set: $fieldType}
        listOptions: {
          deleteMany: {id: {in: $optionsToDelete}}
          createMany: {data: $optionsToCreate}
          update: $optionsToUpdate
        }
      }
    ) {
      id
      field
      isDeleted
      fieldType
      listOptions {
        id
        name
        description
      }
    }
  }
`;
export const SOFT_DELETE_CONDITION = gql`
  mutation SoftDeleteCondition($id: Int!) {
    deleteOneCondition(where: {id: $id}) {
      id
      field
      isDeleted
      fieldType
      listOptions {
        id
        name
        description
      }
    }
  }
`;
export const GET_CONDITION_TYPES = gql`
  query GetConditionTypes {
    conditionType: __type(name: "ConditionType") {
      name
      enumValues {
        name
      }
    }
  }
`;
